var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.dialogVisible,
            direction: _vm.direction,
            size: "1200px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "demo-drawer_title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [_vm._v("订单详情")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "demo-drawer__content",
            },
            [
              _vm.refundInfo.refundOrderNo
                ? [
                    _c("div", { staticClass: "title" }, [_vm._v("退款信息")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "acea-row" }, [
                      _c("div", { staticClass: "description-term" }, [
                        _c("span", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.refundInfo.type === 1,
                              expression: "refundInfo.type === 1",
                            },
                          ],
                          staticClass: "iconfont icon-shipinhao mr5",
                          staticStyle: { color: "#f6ae02" },
                        }),
                        _vm._v(
                          "退款单号：" +
                            _vm._s(_vm.refundInfo.refundOrderNo) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "description-term",
                          staticStyle: { color: "red" },
                        },
                        [
                          _vm._v("\n            退款状态：\n            "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("refundStatusFilter")(
                                  _vm.refundInfo.refundStatus
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "description-term fontColor3" },
                        [
                          _vm._v(
                            "退款金额：" + _vm._s(_vm.refundInfo.refundPrice)
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "description-term fontColor3" },
                        [
                          _vm._v(
                            "退款数量：" + _vm._s(_vm.refundInfo.applyRefundNum)
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "description-term" }, [
                        _vm._v(
                          "退款时间：" + _vm._s(_vm.refundInfo.refundTime)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "description-term" }, [
                        _vm._v(
                          "退款原因：" + _vm._s(_vm.refundInfo.refundReasonWap)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "description-term" }, [
                        _vm._v(
                          "退款说明：" +
                            _vm._s(
                              _vm._f("filterEmpty")(
                                _vm.refundInfo.refundReasonWapExplain
                              )
                            )
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.refundInfo.refundReason
                        ? _c("div", { staticClass: "description-term" }, [
                            _vm._v(
                              "\n            拒绝退款说明：" +
                                _vm._s(
                                  _vm._f("filterEmpty")(
                                    _vm.refundInfo.refundReason
                                  )
                                ) +
                                "\n          "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "description-term acea-row",
                          staticStyle: { width: "100%", display: "flex" },
                        },
                        [
                          _vm._v("\n            退款商品：\n            "),
                          _c(
                            "div",
                            { staticClass: "demo-image__preview" },
                            [
                              _c("el-image", {
                                attrs: {
                                  src: _vm.refundInfo.image,
                                  "preview-src-list": [_vm.refundInfo.image],
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "ml20" }, [
                            _c("div", [
                              _vm._v(_vm._s(_vm.refundInfo.productName)),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.refundInfo.sku +
                                    "x" +
                                    _vm.refundInfo.payNum
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.refundInfo.supplierLogistics
                        ? _c("div", { staticClass: "description-term" }, [
                            _vm._v(
                              "\n            退货物流：\n            " +
                                _vm._s(
                                  _vm.refundInfo.supplierLogistics
                                    ? _vm.refundInfo.supplierLogistics.cpCode +
                                        "/" +
                                        _vm.refundInfo.supplierLogistics
                                          .logisticsNo
                                    : "-"
                                ) +
                                "\n          "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("el-divider"),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.orderDatalist
                ? _c(
                    "div",
                    { staticClass: "description" },
                    [
                      parseFloat(_vm.orderDatalist.shippingType) === 1
                        ? [
                            _c("el-divider"),
                            _vm._v(" "),
                            _c("div", { staticClass: "title" }, [
                              _vm._v("收货信息"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "acea-row" }, [
                              _c("div", { staticClass: "description-term" }, [
                                _vm._v(
                                  "收货人：" +
                                    _vm._s(_vm.orderDatalist.realName)
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "description-term" }, [
                                _vm._v(
                                  "收货电话：" +
                                    _vm._s(_vm.orderDatalist.userPhone)
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "description-term" }, [
                                _vm._v(
                                  "收货地址：" +
                                    _vm._s(_vm.orderDatalist.userAddress)
                                ),
                              ]),
                            ]),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      parseFloat(_vm.orderDatalist.shippingType) === 3
                        ? [
                            _c("el-divider"),
                            _vm._v(" "),
                            _c("div", { staticClass: "title" }, [
                              _vm._v("充值信息"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "acea-row" }, [
                              _c("div", { staticClass: "description-term" }, [
                                _vm._v(
                                  "\n              充值类型：" +
                                    _vm._s(
                                      _vm.orderDatalist.userRechargeInfo
                                        ? _vm.orderDatalist.userRechargeInfo
                                            .accountType == "1"
                                          ? "手机号码"
                                          : "其他"
                                        : "-"
                                    ) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "description-term" }, [
                                _vm._v(
                                  "\n              充值账号：" +
                                    _vm._s(
                                      _vm.orderDatalist.userRechargeInfo
                                        ? _vm.orderDatalist.userRechargeInfo
                                            .rechargeAccount
                                        : "-"
                                    ) +
                                    "\n            "
                                ),
                              ]),
                            ]),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c("el-divider"),
                      _vm._v(" "),
                      _c("div", { staticClass: "title" }, [_vm._v("商品信息")]),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            size: "mini",
                            data: _vm.orderDatalist.orderDetailList,
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { label: "商品图", width: "80" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "demo-image__preview" },
                                        [
                                          _c("el-image", {
                                            attrs: {
                                              src: scope.row.image,
                                              "preview-src-list": [
                                                scope.row.image,
                                              ],
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1825039654
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "商品名称",
                              prop: "productName",
                              "min-width": "200",
                              "show-overflow-tooltip": true,
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "SKU名称",
                              prop: "sku",
                              "min-width": "100",
                              "show-overflow-tooltip": true,
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "price",
                              label: "商品售价",
                              "min-width": "90",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "platformCostPrice",
                              label: "成本价格",
                              "min-width": "90",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "payNum",
                              label: "购买数量",
                              "min-width": "90",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "platformPrice",
                              label: "合计",
                              "min-width": "90",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "发货状态", "min-width": "100" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f(
                                              "supplierOrderLogisticsStatusFilter"
                                            )(scope.row.logisticsStatus)
                                          )
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1417626437
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "操作", "min-width": "100" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.row.channelType === "YYT" &&
                                      scope.row.status !== "8"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "danger",
                                                size: "mini",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleRefuseOrder(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                拒绝订单\n              "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              410138537
                            ),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-divider"),
                      _vm._v(" "),
                      _c("div", { staticClass: "title" }, [_vm._v("订单信息")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "acea-row" }, [
                        _c("div", { staticClass: "description-term" }, [
                          _vm._v(
                            "订单号：" +
                              _vm._s(_vm.orderDatalist.supplierOrderNo)
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "description-term",
                            staticStyle: { color: "red" },
                          },
                          [
                            _vm._v("\n            订单状态：\n            "),
                            _vm.orderDatalist.refundStatus === 3
                              ? _c("span", [_vm._v("已退款")])
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("supplierOrderStatusFilter")(
                                        _vm.orderDatalist.status
                                      )
                                    )
                                  ),
                                ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "description-term",
                            staticStyle: { color: "red" },
                          },
                          [
                            _vm._v(
                              "\n            物流状态：" +
                                _vm._s(
                                  _vm._f("supplierOrderLogisticsStatusFilter")(
                                    _vm.orderDatalist.logisticsStatus
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "description-term" }, [
                          _vm._v(
                            "商品总数：" + _vm._s(_vm.orderDatalist.totalNum)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description-term" }, [
                          _vm._v(
                            "支付方式：" +
                              _vm._s(
                                _vm._f("payTypeFilter")(
                                  _vm.orderDatalist.payType
                                )
                              )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description-term" }, [
                          _vm._v(
                            "\n            配送方式：" +
                              _vm._s(
                                parseFloat(_vm.orderDatalist.shippingType) === 1
                                  ? "邮寄"
                                  : parseFloat(
                                      _vm.orderDatalist.shippingType
                                    ) === 2
                                  ? "门店自提"
                                  : "虚拟充值"
                              ) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description-term" }, [
                          _vm._v(
                            "创建时间：" + _vm._s(_vm.orderDatalist.createTime)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description-term" }, [
                          _vm._v(
                            "用户备注：" +
                              _vm._s(
                                _vm._f("filterEmpty")(
                                  _vm.orderDatalist.userRemark
                                )
                              )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "description-term" }, [
                          _vm._v(
                            "商家备注：" +
                              _vm._s(
                                _vm._f("filterEmpty")(
                                  _vm.orderDatalist.merchantRemark
                                )
                              )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.InvoiceList.length
                        ? [
                            _c("el-divider"),
                            _vm._v(" "),
                            _c("div", { staticClass: "title" }, [
                              _vm._v("物流信息"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-collapse",
                              {
                                staticClass: "InvoiceList",
                                model: {
                                  value: _vm.activeNames,
                                  callback: function ($$v) {
                                    _vm.activeNames = $$v
                                  },
                                  expression: "activeNames",
                                },
                              },
                              [
                                _vm._l(_vm.InvoiceList, function (item) {
                                  return [
                                    _c(
                                      "el-collapse-item",
                                      {
                                        attrs: {
                                          title:
                                            item.expressName +
                                            "：" +
                                            item.trackingNumber,
                                          name: item.id,
                                        },
                                      },
                                      [
                                        _c("template", { slot: "title" }, [
                                          _c(
                                            "div",
                                            { staticClass: "acea-row" },
                                            [
                                              _c("div", [
                                                _vm._v(
                                                  _vm._s(
                                                    item.expressName +
                                                      "：" +
                                                      item.trackingNumber
                                                  )
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "el-button",
                                                {
                                                  directives: [
                                                    {
                                                      name: "hasPermi",
                                                      rawName: "v-hasPermi",
                                                      value: [
                                                        "merchant:order:logistics:info",
                                                      ],
                                                      expression:
                                                        "['merchant:order:logistics:info']",
                                                    },
                                                  ],
                                                  staticStyle: {
                                                    "margin-left": "5px",
                                                    "line-height": "1",
                                                    height: "auto",
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    size: "mini",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.openLogistics(
                                                        item.id
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "物流查询\n                    "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "acea-row" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "wrapper-pro acea-row",
                                            },
                                            _vm._l(
                                              item.detailList,
                                              function (j) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: j.id,
                                                    staticClass: "wrapper-img",
                                                  },
                                                  [
                                                    _c("el-image", {
                                                      attrs: { src: j.image },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "wrapper-num" },
                                          [
                                            _vm._v(
                                              "共" +
                                                _vm._s(item.totalNum) +
                                                "件商品"
                                            ),
                                          ]
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                }),
                              ],
                              2
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _vm.orderDatalist
        ? _c(
            "el-dialog",
            {
              attrs: { title: "提示", visible: _vm.modal2, width: "600px" },
              on: {
                "update:visible": function ($event) {
                  _vm.modal2 = $event
                },
              },
            },
            [
              _c("div", { staticClass: "logistics acea-row row-top" }, [
                _c("div", { staticClass: "logistics_img" }, [
                  _c("img", {
                    attrs: { src: require("@/assets/imgs/expressi.jpg") },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "logistics_cent" }, [
                  _c("span", { staticClass: "mb10" }, [
                    _vm._v("物流公司：" + _vm._s(_vm.resultInfo.expName)),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("物流单号：" + _vm._s(_vm.resultInfo.number)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.resultInfo.courierPhone,
                          expression: "resultInfo.courierPhone",
                        },
                      ],
                    },
                    [_vm._v("快递站：" + _vm._s(_vm.resultInfo.courierPhone))]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.resultInfo.courierPhone,
                          expression: "resultInfo.courierPhone",
                        },
                      ],
                    },
                    [
                      _vm._v(
                        "快递员电话：" + _vm._s(_vm.resultInfo.courierPhone)
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "acea-row row-column-around trees-coadd" },
                [
                  _c(
                    "div",
                    { staticClass: "scollhide" },
                    [
                      _c(
                        "el-timeline",
                        { attrs: { reverse: _vm.reverse } },
                        _vm._l(_vm.result, function (item, i) {
                          return _c("el-timeline-item", { key: i }, [
                            _c("p", {
                              staticClass: "time",
                              domProps: { textContent: _vm._s(item.time) },
                            }),
                            _vm._v(" "),
                            _c("p", {
                              staticClass: "content",
                              domProps: { textContent: _vm._s(item.status) },
                            }),
                          ])
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.modal2 = false
                        },
                      },
                    },
                    [_vm._v("关闭")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }